import SpheronCircleLogo from "@/assets/spheron-logo-circle.svg";
import { DEXS } from "@/config/dexes";
import LinkIcon from "@/assets/link-external.svg";
import Card from "../Card";
import ExploreSpheron from "../ExploreSpheron";

export default function NotEligibleScreen() {
  return (
    <div className="flex lg:w-[45vw] max-w-[960px] flex-col gap-4 items-center mt-[65px]">
      <div className="flex flex-col items-center gap-y-8 lg:max-w-[734px] w-[95%] text-center">
        <div className="font-gilroy-bold text-5xl uppercase text-white">
          No SPON reward found
        </div>
        <div className="flex flex-col gap-y-6 items-center border border-[#333] bg-[#141416] lg:w-[512px] w-[95%] py-[60px] px-6">
          <div>
            <SpheronCircleLogo />
          </div>
          <div className="flex flex-col gap-y-4 leading-6 text-[#9D9D9D] text-center">
            <p>
              It looks like your wallet isn't whitelisted for this SPON reward,
              but you can still be part of the Spheron revolution.
            </p>
            <p>
              Buy <span className="text-white">SPON</span> and join the Spheron
              ecosystem
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
            {DEXS.map((item) => {
              return (
                <a
                  key={item.id}
                  className="basis-[24%]"
                  href={item.link}
                  target="_blank"
                >
                  <Card className="text-[#9D9D9D] hover:text-white hover:border-[#4C4C40] flex !items-center gap-2 px-4 !py-2">
                    {item.logo}
                    {item.name}
                    <LinkIcon className="ml-auto w-4 h-4" />
                  </Card>
                </a>
              );
            })}
          </div>
        </div>
      </div>
      <ExploreSpheron isEligible={false} />
    </div>
  );
}
